import common from "@page/common/js/common";
import corpPage from "@global/components/global/staticInfoPage";

corpPage();

/**
 * @description 依據 href 進行Tab class切換
 */

$(document).ready(function () {
	const element = $(".tab-name");
	element.each(function (index, item) {
		const href = $(this).attr("href");
		if (href && window.location.href.includes(href)) {
			$(this).addClass("active");
		}
	});

	element.click(function (event) {
		element.removeClass("active");
		$(this).addClass("active");
	});
});
